module.exports = __webpack_public_path__ + "img/x-ray1.01f9b491.jpg";